import React, { useState, useEffect } from 'react';
import config from './data/config.json';

const SectionForm = () => {
  const [formSubmitted, setFormSubmitted] = useState(false); // Track submission status
  const pagePath = window.location.pathname;
  const isSubmittedPage = pagePath === '/submitted';

  useEffect(() => {
    const hash = window.location.hash;
    if (hash === '#submitted') {
      setFormSubmitted(true);
      const formSection = document.getElementById('section-form');
      if (formSection) {
        formSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  const encode = (data) => {
    return Object.keys(data)
      .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&');
  };

  const handleSubmit = (e) => {
    const formData = new FormData(e.target);
    const formObject = Object.fromEntries(formData.entries());

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'quote', ...formObject }),
    }).then(() => setFormSubmitted(true));

    e.preventDefault();
  };

  return (
    <section
      className="d-flex align-items-center"
      style={{
        backgroundImage: 'url(./images/kitchen.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <div className="overlay" style={{ zIndex: 1 }}></div>
      <div className="container py-5" style={{ zIndex: 2 }}>
        <div className="row align-items-start">
          <div className="col-12 col-lg-6 text-white mb-4 mb-lg-0">
            <h2 className="display-5 text-left">
              Reliable, Professional Cleaning Services in Barron County, WI
            </h2>
            <p className="text-left">
              Looking for reliable, professional cleaning service, maid service, or housekeeping
              service for your home or business? We’ve got you covered! At I'm Your Huckleberry, we
              pride ourselves on delivering exceptional, customized services while always respecting
              the privacy and security of your home or business. We are committed to providing
              thorough, reliable cleaning while ensuring your space is treated with the care and
              respect it deserves.
            </p>
          </div>

          <div className="col-12 col-lg-6">
            <div className="card p-4 shadow">
              {/* Conditionally render form or success message */}
              {formSubmitted ? (
                <div className="text-center">
                  <h3>Thank you for reaching out!</h3>
                  <p>We will get back to you within 24 hours.</p>
                </div>
              ) : (
                <form
                  name="quote"
                  method="POST"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                  action="/submitted"
                  onSubmit={handleSubmit}
                >
                  <input type="hidden" name="form-name" value="quote" />
                  <p hidden>
                    <label>
                      Don’t fill this out: <input name="bot-field" />
                    </label>
                  </p>

                  <div className="row">
                    <div className="col-12 col-md-12 mb-3">
                      <label htmlFor="full_name" className="form-label">
                        Full Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="full_name"
                        name="full_name"
                        placeholder="Your Full Name"
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-md-12 mb-3">
                      <label htmlFor="phone" className="form-label">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        name="phone"
                        placeholder="###-###-####"
                        required
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="you@example.com"
                      required
                    />
                  </div>

                  <div className="row">

                    {/* address 1 */}
                    <div className="col-12 col-md-12 mb-3">

                      <label htmlFor="address" className="form-label">
                        Address Line 1
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        id="address"
                        name="address"
                        placeholder="Street Address, P.O. Box, or Company Name"
                        required
                      />
                    </div>

                    {/* address 2 */}
                    <div className="col-12 col-md-12 mb-3">

                      <label htmlFor="address" className="form-label">
                        Address Line 2
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        id="address"
                        name="address_2"
                        placeholder="Apartment, suite, unit, building, floor, etc."
                      />
                    </div>

                    {/* city */}
                    <div className="col-12 col-md-8 mb-3">
                      <label htmlFor="city" className="form-label">
                        City
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        id="city"
                        name="city"
                        placeholder="City"
                        required
                      />
                    </div>

                    {/* state */}
                    <div className="col-12 col-md-4 mb-3">
                      <label htmlFor="state" className="form-label">
                        State
                      </label>

                      <select className="form-select" id="state" name="state" required defaultValue="WI">
                        {config.states.map((state, index) => (
                          <option key={index} value={state}>
                            {state}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Zip Code */}
                    <div className="col-12 col-md-12 mb-3">
                      <label htmlFor="zip" className="form-label">
                        Zip Code
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        id="zip"
                        name="zip"
                        placeholder="Zip Code"
                      />
                    </div>

                    {/* service type */}
                    <div className="col-12 col-md-12 mb-3">
                      <label htmlFor="serviceType" className="form-label">
                        Type of Service
                      </label>
                      <select className="form-select" id="serviceType" name="serviceType" required>
                        {config.services.map((service, index) => (
                          <option key={index} value={service.title}>
                            {service.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* number of rooms */}
                  <div className="col-12 col-md-12 mb-3">
                    <label htmlFor="rooms" className="form-label">
                      Number of Rooms
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="rooms"
                      name="rooms"
                      placeholder="Number of Rooms"
                      min="1"
                      required
                    />
                  </div>

                  <button type="submit" className="btn btn-green w-100">
                    Get a Free Quote
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div >
    </section >
  );
};

export default SectionForm;
